import * as React from 'react'
import {Button, Alert}  from 'react-bootstrap'
import ApiCall from '../../components/ApiCall/ApiCall'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
/*
    this class is the page clause
    after using the search bar if we find a website the user will be redirect here to find the note we ave to this site.
    They can also find more details on specific part of the general condition of use of this website. 
*/
interface ClausesProps
{
    location: any;
}

interface ClasesStats
{
    params : any,
    color_name: string,
    [key : string]: any
    moyFraud : number,
    moyGood : number,
    message : string,
    noteStr: String,
    note_glob: any,
    error: boolean,
    loading: boolean
}

export default class Resume extends React.Component<ClausesProps, ClasesStats> {
    
    private api = new ApiCall()

    constructor(props: ClausesProps) {
        super(props);
        this.state = {
            params : new URLSearchParams(this.props.location.search),
            cgu : [],
            color_name: '',
            moyFraud : 0,
            moyGood : 0,
            message : '',
            noteStr: '',
            note_glob: 0,
            error:false,
            loading:true
        };
    }

    writeError() {
        let { error, message } = this.state

        if (error === true) {
            return (
                <>
                    <Alert variant="success">
                        {message}
                        <br/>
                        <br/>
                        <a href="/accueil">Retour à l'accueil</a>
                    </Alert>
                </>
            );
        }
        else {
            return (
                <>
                    <Alert variant="danger">
                        {message}
                        <br/>
                        <br/>
                        <a href="/accueil">Retour à l'accueil</a>
                    </Alert>
                </>
            )
        }
    }

    loadingWhile(){
        return(
            <>
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                <br/>
                <br/>
                <div role="status">
                    <b>Veuillez patienter quelques instants...</b>
                </div>
            </>
        )
    }

    loadingFin(){
        return(
        <>
            {this.state.error
                ? this.writeError()
                : <></>
            }
        </>
        )
    }

    componentDidMount = async () => {
        var totalFrauduleuse = 0;
        var totalGood = 0;
        await this.api.ApiCall("websites?details=true&q=" + this.state.params.get('site'), "GET", {}, localStorage.getItem('AccessToken'))
        .then(request=>{
            this.setState({
                loading : false
            })
            if(request.status === 200)
		    {
                this.setState({
                    moyGood : totalGood,
                    moyFraud : totalFrauduleuse,
                    note_glob: request.data.note,
                    cgu : request.data.cgu,
                    name : request.data.name,
                })
                if (this.state.note_glob <= 100 && this.state.note_glob >= 80)
                {
                    this.setState({
                        noteStr: "A",
                        color_name_glob: "note_global_inter_green"
                    })
                }
                if (this.state.note_glob <= 80 && this.state.note_glob >= 60) {
                    this.setState({
                        noteStr: "B",
                        color_name_glob: "note_global_inter_green"
                    })
                }
                if (this.state.note_glob <= 60 && this.state.note_glob >= 40) {
                    this.setState({
                        noteStr: "C",
                        color_name_glob: "note_global_inter_orange",
                    })
                }
                if (this.state.note_glob <= 40 && this.state.note_glob >= 20) {
                    this.setState({
                        noteStr: "D",
                        color_name_glob: "note_global_inter_red",
                    })
                }
                if (this.state.note_glob <= 20 && this.state.note_glob >= 0) {
                    this.setState({
                        noteStr: "E",
                        color_name_glob: "note_global_inter_red",
                    })
                }
            }
            else if(request.status === 404){
                this.setState({
                    error: true,
                    message: "Nous sommes entrain d'analyser les conditions générales d'utilisation de ce site. Veuillez revenir ultérieurement. Pour plus d'informations, veuillez contacter l'équipe de PrivaSee dans la section 'Nous Contacter'."
                })
            }
            else if(request.status === 202){
                this.setState({
                    error: true,
                    message: "Notre Intelligence Artificielle est entrain d'analyser le site. Veuillez réessayer dans quelques minutes."
                })
            }
        })
		
    }
    
    

	render() {
		return (
			<>	
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
					<div className="hero-wrap js-fullheight">
						<div className="overlay">
						</div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
									<div id="border-search" className="col-md-6 ftco-animate text-center fadeInUp ftco-animated" data-scrollax=" properties: { translateY: '70%' }">
										<br></br>
										<br></br>
										<h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
                                            Clauses des CGU de {this.state.name}
										</h1>
									</div>
								</div>
							</div>
						</div>
					</div>
                    <section className="ftco-section">
                        <div className="container">
                            <div id="row-justify" className="row justify-content-center mb-12 pb-5">
                                <div className="col-md-12 text-center heading-section ftco-animate">
                                    <div>
                                        <span className="subheading">Note Globale de <b>{this.state.name}</b></span>
                                        <br></br>
                                        <br></br>
                                    </div>
                                    <div id="note_global">
                                        <div id={this.state.color_name_glob}>{this.state.noteStr}</div>
                                        <br></br>
                                        Note Globale
                                        <br></br>
                                        <b>{this.state.note_glob}</b>
                                    </div>
                                    <div id="justify-center-clause" className="">
                                    {this.state.cgu.map(function(item : any){
                                        var note = "";
                                        var colors_clauses = "";
                                        var labels="";
                                        let img:any = null;
                                        if(item.note <= 100 && item.note >= 80){
                                            note = "A";
                                            colors_clauses = "note_global_inter_clauses_green";
                                        }
                                        if(item.note <= 80 && item.note >= 60){
                                            note = "B";
                                            colors_clauses = "note_global_inter_clauses_green";
                                        }
                                        if (item.note <= 60 && item.note >= 40) {
                                            note = "C";
                                            colors_clauses = "note_global_inter_clauses_orange";
                                        }
                                        if(item.note <= 40 && item.note >= 20){
                                            note = "D";
                                            colors_clauses = "note_global_inter_clauses_red";
                                        }
                                        if(item.note <= 20 && item.note >= 0){
                                            note = "E";
                                            colors_clauses = "note_global_inter_clauses_red";
                                        }

                                        if(item.labels.length === 0 || item.labels[0] === 0){
                                            labels = "Il n'y a aucun label sur cette charte."
                                        }
                                        if(item.labels[0] === 1){
                                            labels = "Information collection";
                                            img = <i className='fas fa-database mr-2'></i>;
                                        }
                                        if(item.labels[0] === 2){
                                            labels = "Use of information";
                                            img = <i className='fas fa-file-export mr-2'></i>;
                                        }
                                        if(item.labels[0] === 3){
                                            labels = "Third party disclosure";
                                            img = <i className='fas fa-person-booth mr-2'></i>;
                                        }
                                        if(item.labels[0] === 4){
                                            labels = "Information protection";
                                            img = <i className='fas fa-shield-alt mr-2'></i>;
                                        }
                                        if(item.labels[0] === 5){
                                            labels = "Right of users"
                                            img = <i className='fas fa-book mr-2'></i>;
                                        }
                                        if(item.labels[0] === 6){
                                            labels = "Cookies"
                                            img = <i className='fas fa-cookie-bite mr-2'></i>;
                                        }
                                        if(item.labels[0] === 7){
                                            labels = "Notifications of changes"
                                            img = <i className='fas fa-bell mr-2'></i>;
                                        }
                                        
                                        return(
                                            <>
                                                <div id={"cgu_parent"}>
                                                    <div id={colors_clauses}>{note}</div>
                                                    <div id="clause">
                                                        <div id="desc_clauses">Note : <b>{item.note}</b></div>
                                                        <div id="labels_clauses">{img}<b>{labels}</b></div>
                                                    </div>
                                                    <div id="link_clauses">
                                                        <Button id="ButtonClauses" className="fas fa-eye" variant="primary" href={item.url} target="_blank"></Button>
                                                    </div>
                                                </div>
                                            </>
                                        );
                                    })}
                                    </div>
                                    {this.state.loading
                                        ? this.loadingWhile()
                                        : this.loadingFin()
                                    }
                                </div>
                            </div>
                        </div>
                </section>
				<Footer/>
				</div>
			</>
		);
	}

}